import React from "react";
import {
  HelpCircle,
  Cpu,
  Zap,
  Cloud,
  Shield,
  Network,
  Database,
  Code,
  Globe,
  Lightbulb,
  BarChart,
  TrendingUp,
  Smartphone,
  Layers,
  Bot,
  Key,
  Box,
  Boxes,
  Layout,
  Palette,
  Settings,
  Home,
  FileCode,
  Server,
  Coffee,
  Component,
  Flame,
  CloudCog,
  Figma,
  Apple,
  Wind,
  Gem,
  FileJson,
  FileTerminal,
  Container,
  PenTool,
  BrainCircuit,
  // EMR/EHR and Healthcare icons
  Heart,
  RefreshCw,
  Link2,
  FileText,
  Calendar,
  Users,
  DollarSign,
  Pill,
  Building2,
  Lock,
  Award,
  Activity,
  Target,
  BookOpen,
  // Additional icons
  MessageCircle,
  Briefcase,
  Disc,
  Star,
  UserCheck,
  Stethoscope,
  Video,
  Fingerprint,
  Mic,
  ShieldCheck,
  Clipboard,
  Repeat,
  MessageSquare,
  Rocket,
  // Telemedicine mobile app icons
  Brain,
  Bell,
  Languages,
  FileCheck,
  Eye,
  Headphones,
  CreditCard,
  ClipboardList,
  UserCircle,
  Mail,
  Search,
  AlertCircle,
  BarChart3,
  FileImage,
  CalendarRange,
  User,
  Sparkles,
  ArrowLeftRight,
  type LucideIcon,
} from "lucide-react";

import { LiaToothSolid } from "react-icons/lia";

interface DynamicIconProps extends React.ComponentProps<typeof HelpCircle> {
  name: string;
}

// react-icons glyphs (e.g. the Line Awesome tooth icon) sit in a viewBox with
// more internal padding than Lucide's, so at the same className size they
// read visibly smaller. Scale those up so all icons look the same size.
const SIZE_COMPENSATED_ICONS: Record<string, number> = {
  LiaToothSolid: 1.3,
};

// Map of commonly used icon names to components
const iconMap: Record<string, React.ComponentType<any>> = {
  LiaToothSolid,
  HelpCircle,
  Cpu,
  Zap,
  Cloud,
  Shield,
  Network,
  Database,
  Code,
  Globe,
  Lightbulb,
  BarChart,
  TrendingUp,
  Smartphone,
  Layers,
  Bot,
  Key,
  Box,
  Boxes,
  Layout,
  Palette,
  Settings,
  Home,
  FileCode,
  Server,
  Coffee,
  Component,
  Flame,
  CloudCog,
  Figma,
  Apple,
  Wind,
  Gem,
  FileJson,
  FileTerminal,
  Container,
  PenTool,
  BrainCircuit,
  // EMR/EHR and Healthcare icons
  Heart,
  RefreshCw,
  Link2,
  FileText,
  Calendar,
  Users,
  DollarSign,
  Pill,
  Building2,
  Lock,
  Award,
  Activity,
  Target,
  BookOpen,
  // Additional icons
  MessageCircle,
  Briefcase,
  Disc,
  Star,
  UserCheck,
  Stethoscope,
  Video,
  Fingerprint,
  Mic,
  ShieldCheck,
  Clipboard,
  Repeat,
  MessageSquare,
  Rocket,
  // Telemedicine mobile app icons
  Brain,
  Bell,
  Languages,
  FileCheck,
  Eye,
  Headphones,
  CreditCard,
  ClipboardList,
  UserCircle,
  Mail,
  Search,
  AlertCircle,
  BarChart3,
  FileImage,
  CalendarRange,
  User,
  Sparkles,
  ArrowLeftRight,
};

export const DynamicIcon = ({ name, style, ...props }: DynamicIconProps) => {
  const IconComponent = iconMap[name];
  const scale = SIZE_COMPENSATED_ICONS[name];
  const mergedStyle = scale ? { ...style, transform: `scale(${scale})` } : style;

  if (!IconComponent) {
    return <HelpCircle style={mergedStyle} {...props} />;
  }

  return <IconComponent style={mergedStyle} {...props} />;
};
